import { Card, Classes, Colors, H5 } from '@blueprintjs/core';
import { Badge } from 'components/base';
import { TREE_TYPE } from 'editor-utils/template';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import styled, { css } from 'styled-components';

const StyledH5 = styled(H5)`
  margin-bottom: 5px;
`;

const StyledCard = styled(Card)`
  display: flex;
  padding: 15px 15px 10px;
  height: 100%;

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      background: rgba(206, 217, 224, 0.5);
      * {
        opacity: 0.9;
      }
    `};

  ${({ elevation }) =>
    elevation &&
    `
    background: ${Colors.BLUE3};
    color: ${Colors.WHITE};

    .${Classes.HEADING} {
      color: ${Colors.WHITE};
    }
  `}
`;

const StyledImg = styled.img`
  max-width: 110px;
  margin-bottom: 5px;
  margin-left: 5px;
  align-self: center;
`;

const TextContainer = styled.div`
  flex-grow: 1;
`;

const ItemContainer = styled.div`
  margin-bottom: 5px;
`;

const TreeTypeCard = memo(
  ({ className, isSelected, disabled, onSelect, type, name, description, icon }) => {
    const onClick = useCallback(() => {
      if (disabled) {
        return;
      }
      onSelect(type);
    }, [disabled, type, onSelect]);

    return (
      <StyledCard
        className={className}
        elevation={isSelected ? 2 : 0}
        {...(disabled ? { disabled } : { onClick, interactive: true })}
      >
        <TextContainer>
          <StyledH5>
            {name}
            {type === TREE_TYPE.DESC && (
              <>
                {' '}
                <Badge type="success" size="xs">
                  NEW
                </Badge>
              </>
            )}
          </StyledH5>
          {description && (
            <ItemContainer
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          )}
        </TextContainer>
        {icon && <StyledImg alt="" src={icon} />}
      </StyledCard>
    );
  },
);

TreeTypeCard.defaultProps = {
  className: undefined,
  disabled: false,
  isSelected: false,
  onRemove: () => {},
  onSelect: () => {},
};

TreeTypeCard.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  onRemove: PropTypes.func,
  onSelect: PropTypes.func,
};

export default TreeTypeCard;
